import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import ProductionExpensesPaymentForm from "./forms/ProductionExpensesPaymentForm";
import ProductionExpensesPaymentList from "./lists/ProductionExpensesPaymentList";
import Button from "../form/Button";
import Box from "../layout/Box";
import InvoiceEditor, {invoiceTypes, providerTypes} from "./invoiceEditor";
import ModalEditor from "./ModalEditor";
import ComponentConfig from "../form/ComponentConfig";
import InvoiceList from "./lists/invoiceList";

class ProductionExpensePaymentEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    deleteForm = async () => {
        await this.props.deleteForm();
        this.editor && this.editor.hide();
    }

    getFieldProps = (field) => {
        const props = this.props.getFieldProps(field);
        if (this.props.values[this.props.componentConfig.idfield]) {
            props.disabled = props.disabled || true;
        }
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Gyártás költségszámlák"}
                    footer={[
                        <Button
                            key="0"
                            className="pull-left"
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ComponentConfig componentName="invoice">
                        <InvoiceList ref={(el) => this.list = el} {...this.props} selection={(rows) => rows.find((row) => row.component_id + "" === "" + this.props.values[this.props.componentConfig.idfield])} filter={[{field: "component", value: this.props.componentConfig.componentname}]} loadForm={(data) => this.loadForm(data ? {[this.props.componentConfig.idfield]: data.component_id} : {})} />
                    </ComponentConfig>
                    {/*<ProductionExpensesPaymentList ref={(el) => this.list = el} {...this.props} />*/}
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    key={2}
                    theme="default"
                    header="Gyártás"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.deleteForm}
                        >
                            Törlés
                        </Button>
                    ]}
                >
                    <ProductionExpensesPaymentForm {...this.props} getFieldProps={this.getFieldProps} />
                </Editor>
                <Other>
                    {this.props.values[this.props.componentConfig.idfield] && <InvoiceEditor
                        editorContext="ProductionExpensePaymentInvoiceEditor"
                        gridid="ProductionExpensePaymentInvoiceList"
                        pageSize={0}
                        listFilter={[
                            {
                                field: "component",
                                value: this.props.componentConfig.componentname
                            },{
                                field: "component_id",
                                value: this.props.values[this.props.componentConfig.idfield]
                            }
                        ]}
                        editor={ModalEditor}
                        selection={null}
                        onProcessAction={() => {
                            if (!this.props.isLoading) {
                                this.props.reloadForm && this.props.reloadForm();
                            }
                        }}
                    />}
                </Other>
            </Fragment>
        );
    }
}

export default createEditor({
    componentName: "ProductionExpensePayment",
    WrappedComponent: ProductionExpensePaymentEditor,
    props: {
        componentActions: (action, data, params) => {
            data = {...data};
            data.items = Object.keys(data.items).map((key) => data.items[key]);
            return {action,data,params};
        }
    }
});
